import { supabase } from '../config/supabase';
import { User } from '../types/user';

export const signIn = async (email: string, password: string): Promise<{ user: User | null }> => {
  try {
    // 1. Autenticar con Supabase Auth
    const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
      email,
      password
    });

    if (authError) throw authError;
    if (!authData.user) return { user: null };

    // 2. Obtener datos del usuario de nuestra tabla
    const { data: userData, error: userError } = await supabase
      .from('users')
      .select('*')
      .eq('id', authData.user.id)
      .single();

    if (userError || !userData) {
      console.error('Error getting user data:', userError);
      return { user: null };
    }

    return {
      user: {
        id: userData.id,
        email: userData.email,
        name: userData.name,
        role: userData.role,
        propertyId: userData.property_id,
        created_at: userData.created_at
      }
    };
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const signOut = async (): Promise<void> => {
  await supabase.auth.signOut();
};

export const getCurrentUser = async (): Promise<User | null> => {
  try {
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError || !session?.user) {
      return null;
    }

    const { data: userData, error: userError } = await supabase
      .from('users')
      .select('*')
      .eq('id', session.user.id)
      .single();

    if (userError || !userData) {
      return null;
    }

    return {
      id: userData.id,
      email: userData.email,
      name: userData.name,
      role: userData.role,
      propertyId: userData.property_id,
      created_at: userData.created_at
    };
  } catch (error) {
    console.error('Get current user error:', error);
    return null;
  }
};